// extracted by mini-css-extract-plugin
export default {"container":"RiskFactorAutoComplete_container__TkNxo","listContainer":"RiskFactorAutoComplete_listContainer__9QIIn","riskfactorList":"RiskFactorAutoComplete_riskfactorList__YLYtc"};